/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sorgeberechtigteeltern1Inputs */



/**

* @param {_Field_Sorgeberechtigteeltern1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_sorgeberechtigteeltern1 = /** @type {((inputs?: _Field_Sorgeberechtigteeltern1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sorgeberechtigteeltern1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Sorgeberechtigte Eltern")
});
export { _field_sorgeberechtigteeltern1 as "_field_sorgeberechtigteEltern" }